import { Constantes } from "../constants/constantsGlobal";
import { iFeedbackRequest } from "../models/interfaceChatBotFeedback";

export async function chatbotSaveFeedback(request: iFeedbackRequest): Promise<any> {
  try {
    const response = await fetch(Constantes.URI_ChatbotFeedback, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': Constantes.HEADER_CHAT_BOT_TOKEN,  
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Error enviando el mensaje a la API');
    } 
    const data = await response.json(); 
    return data; 
  } catch (error) {
    console.error('Error al enviar el mensaje:', error);
    throw error;
  }
}


